const carousel = {
  es: [
    {
      titulo: "Servicios IoT",
      descripcion: [
        "La mayor calidad de Medidores y red IoT para tu proyecto inmobiliario",
        "Con la alianza WASION - SOFTEL",
      ],
      img: require("../assets/img/carousel/WASION_Landing.png"),
      link: "/servicios/medidores_iot_wasion_softel", 
      order: 2
    },
    {
      titulo: "Productos IoT",
      descripcion: [
        "Consulta, configura y controla el ciclo de enfriamiento desde cualquier smartphone.",
        "Con el nuevo control para refrigeradores y congeladores",
      ],
      img: require("../assets/img/carousel/EasyCool_Landing.png"),
      link: "/contacto",
      order: 3
    },
    {
      titulo: "Productos IoT",
      descripcion: [
        "Keep Running: Siempre conectado, estés donde estés."        
      ],
      img: require("../assets/img/carousel/keep-running-01.png"),      
      link: "/productos/keep_running",
      order: 4
    },
    {
      titulo: "Refrigeración IoT",
      descripcion: [
        "Asegura el óptimo funcionamiento de tus equipos de refrigeración",
        "Con  controles inteligentes de temperatura",
      ],
      img: require("../assets/img/carousel/refrigeracion.webp"),
      link: undefined,
      link2: "https://softel.odoo.com/shop",
      order: 5
    },
    {
      titulo: "Servicios IoT",
      descripcion: [
        "Simplificamos la submedición en cualquier tipo de proyecto",
        "Solución integral SOFTEL ",
      ],
      img: require("../assets/img/carousel/submedicion.png"),
      link: "/servicios/submetering",
      order: 1
    },
  ],
  en: [
    {
      titulo: "IoT Services",
      descripcion: [
        "The Highest Quality Meters and IoT Network for Your Real Estate Project.",
        "With the WASION - SOFTEL Alliance",
      ],
      img: require("../assets/img/carousel/WASION_Landing.png"),
      link: "/servicios/medidores_iot_wasion_softel",
      order: 2
    },
    {
      titulo: "IoT Products",
      descripcion: [
        "Know the temperature of your products. Configure and control the cooling cycle of your refrigerator with the smartphone App. All with EASYCOOL electronic control for refrigerators and freezers.",
      ],
      img: require("../assets/img/carousel/EasyCool_Landing.png"),
      link: "/contacto",
      order: 3
    },
    {
      titulo: "IoT Products",
      descripcion: [
        "Keep Running: Always connected, wherever you are."        
      ],
      img: require("../assets/img/carousel/keep-running-01.png"),
      link: "/productos/keep_running",
      order: 4
    },
    {
      titulo: "IoT Refrigeration",
      descripcion: [
        "Ensure the optimal performance of your refrigeration equipment",
        "With intelligent temperature controls",
      ],
      img: require("../assets/img/carousel/refrigeracion.webp"),
      link: undefined,
      link2: "https://softel.odoo.com/shop",
      order: 5
    },
    {
      titulo: "IoT Services",
      descripcion: [
        "Making submetering simple for any kind of project",
        "SOFTEL Integrated Solution",
      ],
      img: require("../assets/img/carousel/submedicion.png"),
      link: "/servicios/submetering",
      order: 1
    },
  ],
};

export default carousel;
